import GenericBody from "../Componentes/GenericBody";
import NavBar from "../Componentes/NavBar";
import Tabela from "../Componentes/Tabela";

import { useCallback, useEffect, useMemo, useState } from "react";
import GenericHeader from "../Componentes/GenericHeader";
import Filters from "../Componentes/Utils/Filters";
import FilterContainer from "../Componentes/Utils/FilterContainer";
import Stats from "../Componentes/Utils/Stats";
import styled from "styled-components";

import useApi from "../hooks/useApi";
const EPIxFuncao = () => {
    const api = useApi();


    const [ epis, setEpis ] = useState([])
    const [ episFilter, setEpisFilter ] = useState([])

    const fetchData = async () => {

        try{

            const { data } = await api.get('/Painel/API/EPI/EPIxFuncao/index.php')

            console.log( data )
            setEpis( data )
            setEpisFilter( data )

        }catch( e ){

            console.log( e )

        }

    }

    useEffect(() => {

        fetchData();

    }, [])

    const funcoes = useMemo(() => [ ...new Set( epis.map(( obj ) => obj.FUNCAO ))].sort(), [ epis ])
    const ghes = useMemo(() => [ ...new Set( epis.map(( obj ) => obj.GHE ))].sort(), [ epis ])

    const TextContainer = styled.div`
        height: 100%;
        display: flex;
        margin: auto;
    `

    const TotalText = styled.p`
        margin: auto;
        font-size: 18px;
    `

    const [ descricaoFilter, setDescricaoFilter ] = useState('');
    const [ codigoFilter, setCodigoFilter ] = useState('');
    const [ funcaoFilter, setFuncaoFilter ] = useState([]);
    const [ gheFilter, setGheFilter ] = useState([]);

    const handleFilter = useCallback(() => {

        setEpisFilter(
            epis.filter( item => {

                const descricao = !descricaoFilter || item.EPI.toLowerCase().includes( descricaoFilter.toLowerCase() );
                const codigo = !codigoFilter || item.COD_EPI.toLowerCase().includes( codigoFilter.toLowerCase() );
                const funcao = !funcaoFilter.length || funcaoFilter.some( obj => item.FUNCAO.includes( obj.value ) );
                const ghe = !gheFilter.length || gheFilter.some( obj => item.GHE && item.GHE.includes( obj.value ) );

                return descricao && codigo && funcao && ghe;

            })
        )

    }, [ epis, descricaoFilter, codigoFilter, funcaoFilter, gheFilter ]);

    useEffect(() => {
        handleFilter();
    }, [ descricaoFilter, codigoFilter, funcaoFilter, gheFilter, handleFilter ]);

    return(
        <>
            <NavBar title="EPI x FUNÇÃO" prevDest="modulo/ssma/epi" />
            <GenericBody>
                <GenericHeader>
                    <Filters columns={ 2 } >
                        <FilterContainer
                            type="text"
                            placeholder="DESCRIÇÃO DO EPI..."
                            changeFunc={ ( valor ) => setDescricaoFilter( valor ) }
                            valor={ descricaoFilter }
                        />
                        <FilterContainer
                            type="text"
                            placeholder="CÓDIGO DO EPI..."
                            changeFunc={ ( valor ) => setCodigoFilter( valor ) }
                            valor={ codigoFilter }
                        />
                        <FilterContainer
                            type="select"
                            placeholder="FUNÇÃO..."
                            options={ funcoes.map( ( item ) => ({ value: item, label: item }) ) }
                            changeFunc={ ( valor ) => setFuncaoFilter( valor ) }
                            valor={ funcaoFilter }
                        />
                        <FilterContainer
                            type="select"
                            placeholder="GHE..."
                            options={ ghes.map( ( item ) => ({ value: item, label: item }) ) }
                            changeFunc={ ( valor ) => setGheFilter( valor ) }
                            valor={ gheFilter }
                        />
                    </Filters>
                    <Stats>
                        <TextContainer>
                            <TotalText>
                                <b>TOTAL:</b> { episFilter.length }
                            </TotalText>
                        </TextContainer>
                    </Stats>
                </GenericHeader>
                <Tabela>
                    <thead>
                        <tr>
                            <th>FUNÇÃO</th>
                            <th>EPI</th>
                            <th>COD. EPI</th>
                            <th>GHE</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            episFilter.map(( item, index ) => (
                                <tr key={ index } >
                                    <td>{ item.FUNCAO }</td>
                                    <td>{ item.EPI }</td>
                                    <td>{ item.COD_EPI }</td>
                                    <td>{ item.GHE ? item.GHE : '-' }</td>
                                </tr>
                            ))
                        }
                    </tbody>
                </Tabela>
            </GenericBody>
        </>
    )

}

export default EPIxFuncao;